/* ══════════════════════════════════════════════════
   Bailey & Coco — Personalised Dog Tag JS
   ══════════════════════════════════════════════════ */
(function() {
  'use strict';

  // ── Config (set by Liquid) ──
  var variants = window.bcTagVariants || [];
  var currentVariant = variants.length ? variants[0] : null;

  // ── State ──
  var state = {
    frontText: '',
    backLines: ['', '', '', '', '', ''],
    visibleBackLines: 1,
    font: 'classic',
    side: 'front'
  };

  var CHAR_LIMITS = { front: 20, backLine: 25 };
  var MAX_BACK_LINES = 6;

  // ── DOM Cache ──
  var els = {};
  function cacheDom() {
    els.frontInput = document.getElementById('bc-front-text');
    els.frontCounter = document.getElementById('bc-front-counter');
    els.previewLabel = document.getElementById('bc-preview-label');
    els.tagVisual = document.getElementById('bc-tag-visual');
    els.tagImage = document.querySelector('.bc-tag-image');
    els.tagTextArea = document.getElementById('bc-tag-text-area');
    els.tagFrontDisplay = document.getElementById('bc-tag-front-display');
    els.tagSubDisplay = document.getElementById('bc-tag-sub-display');
    els.mainCta = document.getElementById('bc-add-btn');
    els.ctaText = document.getElementById('bc-cta-text');
    els.stickyCta = document.getElementById('bc-sticky-cta-btn');
    els.stickyText = document.getElementById('bc-sticky-text');
    els.addForm = document.getElementById('bc-add-form');
    els.hiddenProps = document.getElementById('bc-hidden-props');
    els.variantId = document.getElementById('bc-variant-id');
    els.addLineBtn = document.getElementById('bc-add-line-btn');
    els.maxLinesNote = document.getElementById('bc-max-lines-note');
    els.miniPreview = document.getElementById('bc-mini-preview');
    els.miniName = document.getElementById('bc-mini-name');
    els.miniSide = document.getElementById('bc-mini-side');
    els.miniImg = document.querySelector('.bc-mini-preview__tag');
    els.previewContainer = document.querySelector('.bc-tag-preview-container');
  }

  // ── Font Map ──
  var FONT_MAP = {
    classic: "Georgia, 'Times New Roman', serif",
    elegant: "'Yellowtail', cursive",
    modern: "'Helvetica Neue', Helvetica, Arial, sans-serif",
    playful: "'Comic Sans MS', 'Chalkboard SE', cursive"
  };


  /* BC_FONT_LABEL - put the real typeface name on the order so production never
     has to translate a slug. Keep this map in step with the @font-face in the
     section and with the font installed in Photoshop. */
  var BC_FONT_LABELS = {
    classic:  'Classic (Georgia)',
    elegant:  'Elegant (Yellowtail)',
    modern:   'Modern (Helvetica Neue / Arial)',
    playful:  'Playful (Comic Sans MS)'
  };
  function bcFontLabel(slug){
    return BC_FONT_LABELS[slug] || slug || '';
  }

  // ── Front tag image URLs (set by Liquid) ──
  var frontImageUrl = window.bcTagFrontImage || '';
  var backImageUrl = window.bcTagBackImage || '';

  // ── Auto Font Sizing ──
  // Script/cursive fonts (Elegant) render visually smaller at the same px
  // size than bold serif/sans — apply a multiplier so all 4 fonts look the
  // same scale on the tag preview.
  var FONT_SIZE_MULT = { classic: 1, elegant: 1.26, modern: 0.95, playful: 1 };

  function applyFontMult(size, font) {
    var m = FONT_SIZE_MULT[font] || 1;
    return Math.round(size * m);
  }

  function getAutoFontSize(text, font) {
    var len = text.length;
    var base;
    if (len > 16) base = 10;
    else if (len > 14) base = 11;
    else if (len > 12) base = 12;
    else if (len > 10) base = 14;
    else if (len > 8) base = 16;
    else if (len > 5) base = 19;
    else base = 22;
    return applyFontMult(base, font);
  }

  function getBackFontSize(lineCount, maxLen, font) {
    var base;
    if (lineCount >= 5) base = 8;
    else if (lineCount === 4) base = 9;
    else if (lineCount === 3) base = maxLen > 16 ? 10 : 11;
    else if (lineCount === 2) base = maxLen > 16 ? 12 : 13;
    else base = maxLen > 16 ? 13 : 15;
    return applyFontMult(base, font);
  }

  // ── Sanitise ──
  function sanitize(val) {
    return val.replace(/[^\w\s\-'&.,@+]/g, '').replace(/\s{2,}/g, ' ');
  }

  // ── Counter ──
  function updateCounter(el, current, max) {
    if (!el) return;
    el.textContent = current + '/' + max;
    el.classList.remove('is-near-limit', 'is-at-limit');
    if (current >= max) el.classList.add('is-at-limit');
    else if (current >= max - 3) el.classList.add('is-near-limit');
  }

  // ── Front Text ──
  function handleFrontInput() {
    state.frontText = sanitize(els.frontInput.value);
    els.frontInput.value = state.frontText;
    updateCounter(els.frontCounter, state.frontText.length, CHAR_LIMITS.front);
    updateTagPreview();
    updateFontPreviews();
    updateMiniPreview();
    updateUI();
  }

  // ── Back Line Input ──
  function handleBackLineInput(index) {
    var input = document.getElementById('bc-back-line-' + (index + 1));
    state.backLines[index] = sanitize(input.value);
    input.value = state.backLines[index];
    var counter = document.getElementById('bc-back-counter-' + (index + 1));
    updateCounter(counter, state.backLines[index].length, CHAR_LIMITS.backLine);

    // Auto-reveal next line (lines 2 and 3 auto-appear when previous has input)
    // Pass focus: false so typing in the current line is NOT interrupted — the
    // user keeps typing where they are; the new empty line just becomes visible.
    if (state.backLines[index].length > 0 && index < 2 && state.visibleBackLines <= index + 1) {
      addBackLine({ focus: false });
    }

    // Show legal nudge when line 2 is visible
    var legalNudge = document.getElementById('bc-legal-nudge');
    if (legalNudge) {
      legalNudge.classList.toggle('is-hidden', state.visibleBackLines < 2);
    }

    updateTagPreview();
    updateMiniPreview();
    updateUI();
  }

  // ── Enter to advance ──
  function handleBackEnter(index, e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (index + 1 < state.visibleBackLines) {
        document.getElementById('bc-back-line-' + (index + 2)).focus();
      } else if (state.visibleBackLines < MAX_BACK_LINES) {
        addBackLine();
      }
    }
  }

  // ── Add Back Line ──
  function addBackLine(opts) {
    if (state.visibleBackLines >= MAX_BACK_LINES) return;
    state.visibleBackLines++;
    var group = document.getElementById('bc-back-line-group-' + state.visibleBackLines);
    group.classList.remove('is-hidden');
    group.classList.add('is-visible');
    var shouldFocus = !opts || opts.focus !== false;
    if (shouldFocus) {
      document.getElementById('bc-back-line-' + state.visibleBackLines).focus();
    }
    els.addLineBtn.style.display = state.visibleBackLines >= MAX_BACK_LINES ? 'none' : '';
    els.maxLinesNote.classList.toggle('is-hidden', state.visibleBackLines < MAX_BACK_LINES);
    showSide('back');
  }

  // ── Remove Back Line ──
  function removeBackLine(index) {
    for (var i = index; i < state.visibleBackLines - 1; i++) {
      state.backLines[i] = state.backLines[i + 1];
      document.getElementById('bc-back-line-' + (i + 1)).value = state.backLines[i];
      var counter = document.getElementById('bc-back-counter-' + (i + 1));
      updateCounter(counter, state.backLines[i].length, CHAR_LIMITS.backLine);
    }
    state.backLines[state.visibleBackLines - 1] = '';
    document.getElementById('bc-back-line-' + state.visibleBackLines).value = '';
    var lastCounter = document.getElementById('bc-back-counter-' + state.visibleBackLines);
    updateCounter(lastCounter, 0, CHAR_LIMITS.backLine);
    var group = document.getElementById('bc-back-line-group-' + state.visibleBackLines);
    group.classList.remove('is-visible');
    group.classList.add('is-hidden');
    state.visibleBackLines--;
    els.addLineBtn.style.display = '';
    els.maxLinesNote.classList.add('is-hidden');
    updateTagPreview();
    updateMiniPreview();
    updateUI();
  }

  // ── Font Selection ──
  function selectFont(btn) {
    document.querySelectorAll('.bc-font-btn').forEach(function(b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    state.font = btn.dataset.font;
    updateTagPreview();
    updateMiniPreview();
    updateUI();
  }

  // ── Show Side ──
  function showSide(side) {
    state.side = side;
    document.querySelectorAll('.bc-tag-side-btn').forEach(function(b) { b.classList.remove('is-active'); });
    var sideBtn = document.querySelector('[data-side="' + side + '"]');
    if (sideBtn) sideBtn.classList.add('is-active');
    if (els.previewLabel) els.previewLabel.textContent = side.toUpperCase();
    // Defensive: only replace the image src if we actually have a URL. Prevents
    // the tag image from disappearing when the admin hasn't uploaded a dedicated
    // back_image in the section settings.
    if (els.tagImage) {
      var nextSrc = side === 'back' ? backImageUrl : frontImageUrl;
      if (nextSrc) els.tagImage.src = nextSrc;
    }
    if (els.tagTextArea) {
      els.tagTextArea.classList.remove('is-front', 'is-back');
      // If admin hasn't uploaded a dedicated back-of-tag image, the back pill
      // still shows the front image. Keep the text overlay on the front
      // engraving-strip position so text doesn't float off-strip.
      var hasDedicatedBack = backImageUrl && backImageUrl !== frontImageUrl;
      var useBackOverlay = side === 'back' && hasDedicatedBack;
      els.tagTextArea.classList.add(useBackOverlay ? 'is-back' : 'is-front');
    }
    updateTagPreview();
    updateMiniPreview();
  }

  // ── Tag Preview ──
  function updateTagPreview() {
    var frontDisplay = els.tagFrontDisplay;
    var subDisplay = els.tagSubDisplay;
    if (!frontDisplay) return;

    if (state.side === 'front') {
      if (state.frontText) {
        frontDisplay.textContent = state.frontText;
        frontDisplay.className = 'bc-tag-front-text font-' + state.font;
        frontDisplay.style.fontSize = getAutoFontSize(state.frontText, state.font) + 'px';
        subDisplay.textContent = '';
      } else {
        frontDisplay.textContent = '';
        frontDisplay.className = 'bc-tag-front-text font-classic';
        frontDisplay.style.fontSize = '';
        frontDisplay.innerHTML = '<span class="bc-tag-placeholder">Dog\'s name</span>';
        subDisplay.textContent = '';
      }
    } else {
      var activeLines = [];
      for (var i = 0; i < state.visibleBackLines; i++) {
        if (state.backLines[i]) activeLines.push(state.backLines[i]);
      }
      if (activeLines.length > 0) {
        var maxLen = 0;
        for (var j = 0; j < activeLines.length; j++) {
          if (activeLines[j].length > maxLen) maxLen = activeLines[j].length;
        }
        var fontSize = getBackFontSize(activeLines.length, maxLen, state.font);
        var lineHeight = activeLines.length > 3 ? '1.2' : activeLines.length > 2 ? '1.25' : '1.4';
        frontDisplay.className = 'bc-tag-back-text font-' + state.font;
        frontDisplay.style.fontSize = fontSize + 'px';
        frontDisplay.style.lineHeight = lineHeight;
        frontDisplay.style.whiteSpace = 'normal';
        frontDisplay.textContent = '';
        for (var k = 0; k < activeLines.length; k++) {
          var div = document.createElement('div');
          div.textContent = activeLines[k];
          frontDisplay.appendChild(div);
        }
        subDisplay.textContent = '';
      } else {
        frontDisplay.textContent = '';
        frontDisplay.className = 'bc-tag-front-text font-classic';
        frontDisplay.style.fontSize = '';
        frontDisplay.style.lineHeight = '';
        frontDisplay.style.whiteSpace = '';
        frontDisplay.innerHTML = '<span class="bc-tag-placeholder">Contact details</span>';
        subDisplay.textContent = '';
      }
    }
  }

  // ── Font Previews ──
  function updateFontPreviews() {
    var name = state.frontText || 'Ruby';
    ['classic', 'elegant', 'modern', 'playful'].forEach(function(f) {
      var el = document.getElementById('bc-font-preview-' + f);
      if (el) el.textContent = name;
    });
  }

  // ── Mini Preview ──
  function updateMiniPreview() {
    if (!els.miniName) return;
    if (state.side === 'front') {
      els.miniName.textContent = state.frontText || "Your dog's name";
      els.miniName.style.fontFamily = FONT_MAP[state.font] || FONT_MAP.classic;
      els.miniSide.textContent = 'FRONT';
    } else {
      els.miniName.textContent = state.backLines[0] || 'Contact details';
      els.miniName.style.fontFamily = FONT_MAP[state.font] || FONT_MAP.classic;
      els.miniSide.textContent = 'BACK';
    }
  }

  function toggleMiniSide() {
    showSide(state.side === 'front' ? 'back' : 'front');
  }

  // ── Init Mini Preview Observer ──
  var miniObserver = null;
  function initMiniPreview() {
    if (!els.previewContainer || !els.miniPreview) return;
    if (miniObserver) { miniObserver.disconnect(); miniObserver = null; }
    if (window.innerWidth > 768) {
      els.miniPreview.classList.remove('is-visible');
      return;
    }
    miniObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        els.miniPreview.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0.05 });
    miniObserver.observe(els.previewContainer);
  }

  // ── Rebuild Hidden Properties ──
  // FIX: Use "Front" and "Back" (capital F and B, rest lowercase)
  // FIX: Combine all back lines into single "Back" property
  function rebuildHiddenProps() {
    if (!els.hiddenProps) return;
    els.hiddenProps.innerHTML = '';

    function addProp(name, value) {
      if (!value) return;
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.value = value;
      els.hiddenProps.appendChild(input);
    }

    // Front: just the dog's name
    addProp('Front', state.frontText);

    // Back: combine all back lines with newline separator
    var backText = [];
    for (var i = 0; i < state.visibleBackLines; i++) {
      if (state.backLines[i]) {
        backText.push(state.backLines[i]);
      }
    }
    if (backText.length > 0) {
      addProp('Back', backText.join('\n'));
    }

    // Font - human-readable for production, raw slug kept hidden for machines
    addProp('Font', bcFontLabel(state.font));
    addProp('_Font code', state.font || 'classic');
  }

  // ── Update UI (State Machine) ──
  function updateUI() {
    var hasFront = state.frontText.length > 0;
    var hasBack = state.backLines[0].length > 0;
    var ready = hasFront && hasBack;

    // Step unlocking
    var step2 = document.getElementById('bc-step-2');
    var step3 = document.getElementById('bc-step-3');
    if (step2) step2.classList.toggle('is-disabled', !hasFront);
    if (step3) step3.classList.toggle('is-disabled', !hasBack);

    // Badges
    setBadge('bc-badge-1', hasFront, true);
    if (hasFront) setBadge('bc-badge-2', hasBack, true);
    if (hasBack) setBadge('bc-badge-3', true, true);

    // CTA
    var ctaCopy = '';
    if (!hasFront) {
      ctaCopy = "Start by entering your dog's name";
    } else if (!hasBack) {
      ctaCopy = 'Now add your contact details';
    } else {
      var price = currentVariant ? (currentVariant.price / 100).toFixed(2) : '14.00';
      ctaCopy = 'Add to Bag - \u00A3' + price;
    }

    if (els.ctaText) els.ctaText.textContent = ctaCopy;
    if (els.mainCta) {
      els.mainCta.disabled = !ready;
      els.mainCta.classList.toggle('is-ready', ready);
    }
    if (els.stickyText) els.stickyText.textContent = ctaCopy;
    if (els.stickyCta) {
      els.stickyCta.disabled = !ready;
      els.stickyCta.classList.toggle('is-ready', ready);
    }

    // Keep hidden properties inputs in sync with state on EVERY UI update.
    // This is load-bearing: Smart Cart's click handler (sc-drawer-v2.js:489)
    // reads `new FormData(form)` the instant the Add button is clicked, BEFORE
    // the form's submit event fires. If bc-hidden-props is empty at that moment,
    // properties[*] never reach Shopify and orders arrive with zero personalisation
    // data (incident BAC-UK-38982 / -38984 / -39038).
    rebuildHiddenProps();
  }

  function setBadge(id, isDone, isActive) {
    var badge = document.getElementById(id);
    if (!badge) return;
    if (isDone) {
      badge.classList.remove('is-active');
      badge.classList.add('is-done');
      badge.innerHTML = '&#10003;';
    } else if (isActive) {
      badge.classList.add('is-active');
      badge.classList.remove('is-done');
      badge.textContent = id.replace('bc-badge-', '');
    }
  }

  // ── Form Submit ──

  // Build the line-item properties payload from state. Mirrors what
  // rebuildHiddenProps() writes as hidden inputs, so the canonical
  // /cart/add.js POST carries exactly the data the form would submit.
  function buildProperties() {
    var props = {};
    if (state.frontText) props['Front'] = state.frontText;
    var backText = [];
    for (var i = 0; i < state.visibleBackLines; i++) {
      if (state.backLines[i]) backText.push(state.backLines[i]);
    }
    if (backText.length > 0) props['Back'] = backText.join('\n');
    props['Font'] = bcFontLabel(state.font || 'classic');
    props['_Font code'] = state.font || 'classic';
    return props;
  }

  // Submit via fetch to /cart/add.js so properties are carried in the JSON
  // body. Bypasses any global form-submit interception (e.g. Smart Cart)
  // that was stripping properties[*] hidden inputs.
  function submitToCart(variantId, properties) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1, properties: properties })
    }).then(function(resp) {
      if (!resp.ok) {
        return resp.text().then(function(txt) {
          var msg = 'Add to cart failed (' + resp.status + ')';
          try { var j = JSON.parse(txt); if (j.description) msg = j.description; } catch(_) {}
          throw new Error(msg);
        });
      }
      return resp.json();
    }).then(function(item) {
      var drawerHandled = false;
      if (window.CartDrawer && typeof window.CartDrawer.refresh === 'function') {
        try { window.CartDrawer.refresh(); } catch(_) {}
        if (typeof window.CartDrawer.open === 'function') {
          try { window.CartDrawer.open(true); drawerHandled = true; } catch(_) {}
        }
      }
      try { document.dispatchEvent(new CustomEvent('cart:refresh',  { bubbles: true })); } catch(_) {}
      try { document.dispatchEvent(new CustomEvent('cart:updated',  { bubbles: true, detail: { item: item } })); } catch(_) {}
      if (!drawerHandled) {
        setTimeout(function() { window.location.href = '/cart'; }, 400);
      }
      return item;
    });
  }

  var isSubmitting = false;
  function handleSubmit(e) {
    if (e) e.preventDefault();
    if (isSubmitting) return;
    if (!state.frontText || !state.backLines[0]) return;

    isSubmitting = true;
    rebuildHiddenProps(); // keep DOM hidden inputs in sync for any analytics/listeners
    var variantId = els.variantId ? els.variantId.value : (currentVariant && currentVariant.id);
    submitToCart(variantId, buildProperties()).catch(function(err) {
      console.error('Cart add failed:', err);
      alert(err.message || 'Unable to add to cart. Please try again.');
      isSubmitting = false;
    });
  }

  function handleStickyClick() {
    if (state.frontText && state.backLines[0]) {
      handleSubmit();
    } else {
      // Scroll to first incomplete step
      var target = !state.frontText ? document.getElementById('bc-step-1') :
                   document.getElementById('bc-step-2');
      if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }

  // ── Init ──
  function init() {
    cacheDom();
    initMiniPreview();
    window.addEventListener('resize', initMiniPreview);

    // Front text
    if (els.frontInput) {
      els.frontInput.addEventListener('input', handleFrontInput);
      els.frontInput.addEventListener('focus', function() { showSide('front'); });
    }

    // Back lines
    for (var i = 0; i < 6; i++) {
      (function(idx) {
        var input = document.getElementById('bc-back-line-' + (idx + 1));
        if (input) {
          input.addEventListener('input', function() { handleBackLineInput(idx); });
          input.addEventListener('focus', function() { showSide('back'); });
          input.addEventListener('keydown', function(e) { handleBackEnter(idx, e); });
        }
      })(i);
    }

    // Add line button
    if (els.addLineBtn) els.addLineBtn.addEventListener('click', addBackLine);

    // Remove line buttons
    document.querySelectorAll('.bc-remove-line').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var idx = parseInt(btn.dataset.index);
        removeBackLine(idx);
      });
    });

    // Font buttons
    document.querySelectorAll('.bc-font-btn').forEach(function(btn) {
      btn.addEventListener('click', function() { selectFont(btn); });
    });

    // Side toggle
    document.querySelectorAll('.bc-tag-side-btn').forEach(function(btn) {
      btn.addEventListener('click', function() { showSide(btn.dataset.side); });
    });

    // Mini preview toggle
    var miniToggle = document.getElementById('bc-mini-toggle');
    if (miniToggle) miniToggle.addEventListener('click', toggleMiniSide);

    // Sticky CTA
    if (els.stickyCta) els.stickyCta.addEventListener('click', handleStickyClick);

    // Main CTA form - prevent default and use handleSubmit
    if (els.addForm) {
      els.addForm.addEventListener('submit', function(e) {
        e.preventDefault();
        handleSubmit();
      });
    }

    // Set initial variant
    if (currentVariant && els.variantId) {
      els.variantId.value = currentVariant.id;
    }

    updateUI();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
